import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import mixpanel from 'mixpanel-browser';
import { Layout } from "antd";
import Sidebar from '../Layout/Sidebar';
import CustomHeader from '../Layout/Header';
import { dataUser } from '../Helpers/util';

const userDataLocal = dataUser();
const UserObj = JSON.parse(userDataLocal);

function GiftPointReward() {
    const [sos, setSos] = useState(null);
    const [collapsed, setCollapsed] = useState(true);

    // Function to toggle sidebar
    const toggleCollapsed = () => {
        setCollapsed((prevState) => !prevState);
    };

    // Function to track button click with Mixpanel
    const rewardDashClick = () => {
        if (UserObj) {
            mixpanel.track('Redeemable Points Reward Button', {
                PageName: 'Corporate Gifting',
                UserEmail: UserObj.email,
                UserName: `${UserObj.fname} ${UserObj.lname}`,
                UserId: UserObj.rec_id,
                CompanyId: UserObj.company_id,
                CompanyName: UserObj.company_name,
                Type: 'Redeemable Points Reward Button',
            });
        }
    };

    // Fetch the Reward Kart URL
    useEffect(() => {
        const authToken = JSON.parse(localStorage.getItem('headData'));

        const sosLogin = async () => {
            try {
                const param = { userId: JSON.stringify(UserObj?.rec_id) };
                const response = await axios.post(
                    `${process.env.REACT_APP_PROD_URL}getData/getRewardKartLoginDetailsForUpload`,
                    param,
                    {
                        headers: { Authorization: authToken?.spintlyToken },
                    }
                );

                if (response.data?.redirectionLink) {
                    setSos(response.data.redirectionLink);
                } else {
                    console.warn("No redirection link found in API response!");
                }
            } catch (error) {
                console.error("Error fetching reward kart URL:", error);
            }
        };

        sosLogin();
    }, []);

    return (
        <>
            <Layout>
                {/* Sidebar */}
                <Sidebar collapsed={collapsed} />

                {/* Header */}
                <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />

                {/* Main Content */}
                <Layout className={collapsed ? 'no_pad_page PageLayout CollapsedPageLayout' : 'no_pad_page PageLayout'}>
                    <div className="PageContent">
                        {sos ? (
                            <div className="WebsiteIframeContainer">
                                {/* Iframe with the reward kart link */}
                                <iframe
                                    allow-same-origin
                                    src={sos}
                                    frameBorder="0"
                                    id="iframe"
                                    title="Gift Reward"
                                    width="100%"
                                    height="800px"
                                    onError={() => {
                                        console.warn("Iframe failed to load. Opening in new tab.");
                                        setSos(null); // Reset state to show fallback link
                                    }}
                                ></iframe>

                                {/* Reward Dashboard Button */}
                                <a
                                    role="button"
                                    href="corporate-gifting"
                                    onClick={rewardDashClick}
                                    className="RewardHomeFloatBTN RewardHomeFloatBTN_effect"
                                >
                                    Reward Dashboard
                                </a>
                            </div>
                        ) : (
                            // Fallback: Open in a new tab if iframe is blocked
                            <div className="text-center">
                                <p>⚠️ The reward page couldn't be loaded in an iframe.</p>
                                {sos !== null && (
                                    <a href={sos} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                                        Open Rewards Page
                                    </a>
                                )}
                            </div>
                        )}
                    </div>
                </Layout>
            </Layout>
        </>
    );
}

export default connect()(GiftPointReward);
